import { Box, Center, Text } from '@mantine/core';
import cx from 'clsx';
import { Icon } from 'src/components/Icon';

import styles from './styles/requirement.styles.module.css';

export const Requirement = ({
  meets,
  label,
}: {
  meets: boolean;
  label: string;
}) => (
  <Text
    component="div"
    className={cx({
      [styles.requirement]: true,
      [styles.requirementMeets]: meets,
    })}
  >
    <Center inline>
      {meets ? (
        <Icon
          className={cx({
            [styles.iconCheck]: true,
          })}
          name="check"
        />
      ) : (
        <Icon
          className={cx({
            [styles.iconCross]: true,
          })}
          name="close"
        />
      )}
      <Box ml={7}>{label}</Box>
    </Center>
  </Text>
);
